import { render, staticRenderFns } from "./ArticleTagList.vue?vue&type=template&id=acc2c7e2&scoped=true"
import script from "./ArticleTagList.vue?vue&type=script&lang=js"
export * from "./ArticleTagList.vue?vue&type=script&lang=js"
import style0 from "./ArticleTagList.vue?vue&type=style&index=0&id=acc2c7e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc2c7e2",
  null
  
)

export default component.exports